import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ConsentPromptV2 from 'conversations-visitor-experience-components/visitor-widget/components/ConsentPromptV2';
import ConsentPrompt from 'conversations-visitor-experience-components/visitor-widget/ConsentPrompt';
import { CHAT_THREAD } from 'conversations-visitor-experience-components/visitor-widget/constants/consentPromptVariants';
import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EVENT_NAMES } from '../../usage-tracking/constants/eventNames';
import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { getShouldUseConsentPromptV2 } from '../../widget-data/selectors/widgetDataSelectors';
import { getIsPortal53 } from '../../widget-data/operators/getIsPortal53';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { jsx as _jsx } from "react/jsx-runtime";
const ConsentPromptWrapper = styled.div.withConfig({
  displayName: "ProcessConsentPrompt__ConsentPromptWrapper"
})(["padding:12px 16px;"]);
const ProcessConsentPrompt = ({
  closeConsentToProcess,
  consentToProcess,
  consentToProcessError,
  consentToProcessMessage,
  dismissConsentToProcessError = () => {},
  showGdprConsentToProcessButton = false,
  trackInteraction
}) => {
  const isAIChatBot = useSelector(getIsAIChatbot);
  const shouldUseConsentPromptV2 = useSelector(getShouldUseConsentPromptV2);
  const widgetColoring = useSelector(getColoring);
  useEffect(() => {
    trackInteraction === null || trackInteraction === void 0 || trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'view consent to process'
    });
  }, [trackInteraction]);
  if (consentToProcessError) {
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      children: /*#__PURE__*/_jsx(ChatAreaAlert, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.offline.title"
        }),
        onClose: dismissConsentToProcessError
      })
    });
  }
  if (shouldUseConsentPromptV2) {
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      children: /*#__PURE__*/_jsx(ConsentPromptV2, {
        variant: CHAT_THREAD,
        showConsentButton: showGdprConsentToProcessButton,
        consentMessage: consentToProcessMessage,
        onConsentAccept: consentToProcess,
        showDivider: false,
        isAIChatBot: isAIChatBot,
        accentColor: widgetColoring === null || widgetColoring === void 0 ? void 0 : widgetColoring.accentColor
      })
    });
  }
  return /*#__PURE__*/_jsx(ConsentPrompt, {
    showButton: showGdprConsentToProcessButton,
    message: consentToProcessMessage || '',
    onClick: consentToProcess || (() => {}),
    onClose: closeConsentToProcess,
    isPortal53: getIsPortal53()
  });
};
ProcessConsentPrompt.displayName = 'ProcessConsentPrompt';
export default ProcessConsentPrompt;